import React, { useContext, useEffect, useState } from "react";
import '../../App.scss'
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement, AddressElement, } from "@stripe/react-stripe-js";
import AuthContext from "../../Context/AuthContext";
import { createCustomer, fetchOrganisationDetails, fetchPaymentMethodId, fetchSavedCards } from "../../api";
import { useNavigate, useParams } from "react-router-dom";
import paymentDropdown from "../../Assets/Images/paymentDropdown.svg";
import cvc from "../../Assets/Images/CVC.svg";
import mastercard from "../../Assets/Images/mastercard.png";
import visa from "../../Assets/Images/visa.png";
import ax from "../../Assets/Images/ax.png";
import jcb from "../../Assets/Images/jcb.png";
import { CircularProgress } from "@mui/material";
import { OfflinePinRounded } from "@mui/icons-material";
import { toast } from "react-toastify";
import { TokenContext } from "../../Context/TokenContext";

const stripePromise = loadStripe( `${process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY}` );
const cardElementStyle = {
  options: {
    autoComplete: "off"
  },
  style: {
    base: {
      fontSize: "16px",
      color: "#32325d",
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', "::placeholder": { color: "#aab7c4", },
      iconColor: "#666EE8", ":-webkit-autofill": { color: "#32325d", },
      padding: "10px 12px",
      border: "1px solid #e4e4e4",
      borderRadius: "4px",
      backgroundColor: "white",
    },
    invalid: { color: "#fa755a", iconColor: "#fa755a", },
  },
};

const NewCardForm = ({ switchToBuyTab, totalTokens }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const tokenCtx = useContext(TokenContext)
  const orgId = localStorage.getItem("orgId");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({ cardinfo: "", cardholdername: "", address: false, });
  const [cardFocused, setCardFocused] = useState(false)

  const [cardInfo, setCardInfo] = useState({
    cardNumber: "",
    expMonth: "",
    expYear: "",
    cvv: "***",
  });
  
  const [useSavedCard, setUseSavedCard] = useState({ cardNumber: true, expiry: true, cvv: true });
  const [hasSavedCard, setHasSavedCard] = useState(false);

  const handleCardChange = (event, field) => {
    setErrors((prev) => ({
      ...prev,
      [field]: event.error ? event.error.message : "",
    }));
  };

  console.log('email', email)
  console.log('name', name)

  const fetchPaymentMethods = async () => {
    const apiUrl = `https://api.stripe.com/v1/payment_methods?customer=${authCtx?.customerId}&type=card`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_API_KEY}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error?.message || "Failed to fetch payment methods");
      }

      console.log("card data", data);

      if (data?.data?.length > 0) {
        const card = data.data[0].card;

        setCardInfo({
          cardNumber: `xxxx xxxx xxxx ${card.last4}`,
          expMonth: card.exp_month.toString().padStart(2, "0"),
          expYear: card.exp_year.toString().slice(-2),
          cvv: "***",
        });

        setUseSavedCard({ cardNumber: true, expiry: true, cvv: true });
        setHasSavedCard(true);
      } else {
        setHasSavedCard(false);
      }
    } catch (error) {
      console.error("Error fetching payment methods:", error);
      setHasSavedCard(false);
    }
  };


  const handleSubmit = async (event) => {
  event.preventDefault();
  setMessage("");
  setIsProcessing(true);

  if (!name || !email) {
    setMessage("Name and email are required.");
    setIsProcessing(false);
    return;
  }

  const cardNumberElement = elements.getElement(CardNumberElement);
  const cardExpiryElement = elements.getElement(CardExpiryElement);
  const cardCvcElement = elements.getElement(CardCvcElement);
  const addressElement = elements.getElement("address");
  const { value } = await addressElement.getValue();

  let hasErrors = false;
  const newErrors = {};

  if (!cardNumberElement?._complete) {
    newErrors.cardinfo = "Please enter a valid card number.";
    hasErrors = true;
  }
  if (!cardExpiryElement?._complete) {
    newErrors.cardexpiry = "Please enter a valid expiry date.";
    hasErrors = true;
  }
  if (!cardCvcElement?._complete) {
    newErrors.cardcvc = "Please enter a valid CVC code.";
    hasErrors = true;
  }
  if (!value?.address?.postal_code) {
    newErrors.address = "Please complete the billing address.";
    hasErrors = true;
  }

  setErrors(newErrors);
  if (hasErrors) {
    setIsProcessing(false);
    return;
  }

  try {
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardNumberElement,
      billing_details: {
        name,
        email,
        address: {
          line1: value.address.line1,
          line2: value.address.line2,
          city: value.address.city,
          state: value.address.state,
          postal_code: value.address.postal_code,
          country: value.address.country,
        },
      },
    });

    if (error) {
      console.error("Stripe error:", error);
      setMessage(error.message);
      setIsProcessing(false);
      return;
    }

    const customerResponse = await createCustomer(
      email,
      name,
      orgId,
      paymentMethod.id
    );

    if (customerResponse.status !== "success") {
      setMessage(customerResponse.error || "Error creating customer");
      setIsProcessing(false);
      return;
    }


    // if customerResponse == success && createPaymentMethod didn't threw an error
    toast.success("Card added successfully")
    tokenCtx?.setRefreshCards(true)

    const customerId = customerResponse.customerId;
    authCtx.addCustomerId(customerId);

    const token = localStorage.getItem('token')
    
    const paymentMethodIdList = await fetchSavedCards(customerId, token);
    const newPaymentMethodId = paymentMethodIdList?.[0]?.id;
    if (newPaymentMethodId) {
      authCtx.addPaymentMethodId(newPaymentMethodId);
    }

    // navigate("/token-checkout", { state: { totalTokens } });
    navigate("/tokens", { state: { totalTokens } });
    switchToBuyTab()
  } catch (err) {
    console.error("Payment submission error:", err);
    setMessage(err.message || "Invalid card details");
  }

  setIsProcessing(false);
};
  const handleAddressChange = (event) => {
    setErrors({ ...errors, address: event.complete })
  };

  const isValidUSZip = (zip) => {
    return /^\d{5}(-\d{4})?$/.test(zip); // Allows 5-digit ZIP or ZIP+4 format
  };

  const onFocus = (e, name) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  }


  useEffect(() => {
    const fetchOrgDetails = async () => {
      setIsProcessing(true)
      const orgDetails = await fetchOrganisationDetails(orgId)
      console.log("orgDetails", orgDetails)

      if (orgDetails?.status == "success") {
        const firstName = orgDetails?.data?.userData?.[0]?.firstName
        const lastName = orgDetails?.data?.userData?.[0]?.lastName
        const fetchedEmail = orgDetails?.data?.userData?.[0]?.email
        setEmail(fetchedEmail)
        setName(firstName + " " + lastName)
        setIsProcessing(false)
      }
    }
    fetchOrgDetails()
  }, [])

  console.log(email)
  console.log(name)
  //logs 
  // console.log("errors",errors)

  const handleCardFocus = () => setCardFocused(true)
  const handleCardBlur = () => setCardFocused(false)

  console.log('errors', errors)
  console.log("stripe", stripe);
  console.log("elements", elements);
  // console.log("cardNumberElement", cardNumberElement);
  // console.log("address value", value);

  return (
    <>
    <div className="new-card-heading">Payment Method</div>
      <form onSubmit={handleSubmit} className="new-card-form">
        <div className="add-new-card">
          <div className="input-box">
            <div className="card-element-wrapper">
              <div className="card-details-container">
              <div className="card-details-heading">Card Details</div>

              <div className="card-information">Card Information<span className="asterisk-mark">*</span></div>
              <div className={`card-element-container ${cardFocused === true ? "focused" : ""}`} style={{ border: "1px solid #C7C7C7", borderRadius: "8px", marginBottom: "10px", backgroundColor: "white", padding: '2px' }} >
                <div className="stripe-input full-width" style={{ position: "relative", padding: "12px", borderBottom: '1px solid #C7C7C7' }} >
                  <div style={{ width: "100%" }}>
                    <CardNumberElement options={cardElementStyle} onChange={(e) => handleCardChange(e, "cardinfo")}  onFocus={handleCardFocus} onBlur={handleCardBlur} />
                  </div>
                  <div style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", display: "flex", gap: "5px", }} >
                    <img src={visa} alt="Visa" style={{ width: "30px", height: "20px" }} />
                    <img src={mastercard} alt="Mastercard" style={{ width: "30px", height: "20px" }} />
                    <img src={ax} alt="American Express" style={{ width: "30px", height: "20px" }} />
                    <img src={jcb} alt="JCB" style={{ width: "30px", height: "20px" }} />
                  </div>
                </div>

                <div className="expiry-cvc-container" style={{ display: "flex", backgroundColor: "white" }} >
                  <div className="expiry" style={{ flex: 1, alignItems: "center", padding: "12px", borderRight: "1px solid #C7C7C7" }} >
                    <CardExpiryElement options={cardElementStyle} onChange={(e) => handleCardChange(e, "cardexpiry")}  onFocus={handleCardFocus} onBlur={handleCardBlur} />
                  </div>
                  <div className="cvc" style={{ flex: 1, position: "relative", alignItems: "center", position: "relative", padding: "12px", }}>
                    <CardCvcElement options={cardElementStyle} onChange={(e) => handleCardChange(e, "cardcvc")}  onFocus={handleCardFocus} onBlur={handleCardBlur} />
                    <img src={cvc} alt="CVC Icon" style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "23px", height: "21px", }} />
                  </div>
                </div>

              </div>
              {(errors.cardinfo || errors.cardexpiry || errors.cardcvc) && <div className="form-error">Please enter valid card information</div>}
              </div>
              <div className="address-container">
              <div className="card-details-heading">Billing Details</div>
                <AddressElement options={{ mode: "billing" }} onChange={handleAddressChange}/>
                {(errors.address) && <div className="form-error">{errors?.address}</div>}
                <button type="submit" onClick={(e) => { handleSubmit(e); }} disabled={!stripe || isProcessing} className="update-card" >
                  {isProcessing ? <CircularProgress color="inherit" size={24} /> : "Update" }
                </button>
                {message && <span className="form-error">{message}</span>}

              </div>
            </div>
            {/* <button type="submit" onClick={(e) => { handleSubmit(e); }} disabled={!stripe || isProcessing} className="create-account" >
              {isProcessing ? <CircularProgress color="inherit" size={24} /> : "Update"}
              </button> */}
            
          </div>
        </div>
      </form>
    </>
  );
};

const AddNewCard = ({ switchToBuyTab, totalTokens }) => {
  return (
    <Elements stripe={stripePromise}>
      <NewCardForm switchToBuyTab={switchToBuyTab} totalTokens={totalTokens} />
    </Elements>
  );
};

export default AddNewCard;
